var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 376 272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#noactivity)",
    fillRule: "evenodd",
    d: "M39.713 198.345c58.563 83.268 108.919 63.332 234.917 19.7C388.125 188.253 409.331 28.096 322.945 6.693c-94.026-23.295-65.879 25.446-154.88 18.813C-49.478 9.294-11.717 125.217 39.713 198.345Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B25F",
    fillRule: "evenodd",
    d: "M303.404 260.086h-2.986V131.133h10.216l-.157 128.953h-7.073Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B25F",
    d: "M79.844 131.133h101.699v128.953H79.844z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B25F",
    fillRule: "evenodd",
    d: "M79.294 126.092h234.45a5.042 5.042 0 0 1 0 10.08H79.294a5.041 5.041 0 0 1 0-10.08Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8984D",
    fillRule: "evenodd",
    d: "M87.66 140.34h86.068v22.105H87.66V140.34Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B25F",
    fillRule: "evenodd",
    d: "M122.899 145.49h15.67a1.39 1.39 0 0 1 1.391 1.391v2.737a1.39 1.39 0 0 1-1.391 1.39h-15.67a1.39 1.39 0 0 1-1.391-1.39v-2.737a1.39 1.39 0 0 1 1.391-1.391Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8984D",
    fillRule: "evenodd",
    d: "M87.828 166.611h86.068v22.106H87.828v-22.106Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B25F",
    fillRule: "evenodd",
    d: "M123.024 171.764h15.67a1.39 1.39 0 0 1 1.391 1.39v2.737a1.39 1.39 0 0 1-1.391 1.391h-15.67a1.39 1.39 0 0 1-1.391-1.391v-2.737c0-.768.622-1.39 1.391-1.39Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8984D",
    fillRule: "evenodd",
    d: "M87.828 192.883h86.068v22.105H87.828v-22.105Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B25F",
    fillRule: "evenodd",
    d: "M123.024 198.035h15.67a1.39 1.39 0 0 1 1.391 1.391v2.737a1.39 1.39 0 0 1-1.391 1.39h-15.67a1.39 1.39 0 0 1-1.391-1.39v-2.737a1.39 1.39 0 0 1 1.391-1.391Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8984D",
    fillRule: "evenodd",
    d: "M87.828 219.156h86.068v22.106H87.828v-22.106Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B25F",
    fillRule: "evenodd",
    d: "M123.024 224.309h15.67a1.39 1.39 0 0 1 1.391 1.39v2.737a1.39 1.39 0 0 1-1.391 1.391h-15.67a1.39 1.39 0 0 1-1.391-1.391v-2.737c0-.768.622-1.39 1.391-1.39Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8984D",
    fillRule: "evenodd",
    d: "M105.485 249.189h48.75c.768 0 1.39.623 1.39 1.391v2.737a1.39 1.39 0 0 1-1.39 1.391h-48.75a1.39 1.39 0 0 1-1.391-1.391v-2.737a1.39 1.39 0 0 1 1.391-1.391Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F97B9",
    fillRule: "evenodd",
    d: "m150.906 123.964 3.547-16.69c0-2.329 1.558-4.235 3.462-4.235h9.744c1.905 0 3.463 1.906 3.463 4.235l3.546 16.69h-23.762Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E8F5",
    fillRule: "evenodd",
    d: "M122.426 48.451h81.004a3.476 3.476 0 0 1 3.476 3.477v56.797a3.476 3.476 0 0 1-3.476 3.477h-81.004a3.477 3.477 0 0 1-3.477-3.477V51.928a3.477 3.477 0 0 1 3.477-3.477Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M122.286 47.09h81.003a3.477 3.477 0 0 1 3.477 3.477v56.797a3.477 3.477 0 0 1-3.477 3.477h-81.003a3.477 3.477 0 0 1-3.477-3.477V50.567a3.477 3.477 0 0 1 3.477-3.477Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F97B9",
    fillRule: "evenodd",
    d: "M118.809 99.614V51.902c0-2.647 1.915-4.812 4.255-4.812h79.446c2.34 0 4.256 2.165 4.256 4.812v47.712h-87.957Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F8",
    fillRule: "evenodd",
    d: "M125.153 50.898h75.273c1.152 0 2.086.934 2.086 2.087v40.734a2.086 2.086 0 0 1-2.086 2.086h-75.273a2.086 2.086 0 0 1-2.087-2.086V52.985c0-1.153.934-2.087 2.087-2.087Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F97B9",
    fillRule: "evenodd",
    d: "M150.211 124.09h25.154c.595 0 1.078.482 1.078 1.078v.924h-27.31v-.924c0-.596.482-1.078 1.078-1.078Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M132.528 60.486h22.898a2.782 2.782 0 0 1 2.782 2.782v22.898a2.782 2.782 0 0 1-2.782 2.782h-22.898a2.781 2.781 0 0 1-2.782-2.782V63.268a2.781 2.781 0 0 1 2.782-2.782ZM170.09 60.102h22.899a2.781 2.781 0 0 1 2.781 2.781v22.898a2.781 2.781 0 0 1-2.781 2.782H170.09a2.781 2.781 0 0 1-2.781-2.782V62.883a2.781 2.781 0 0 1 2.781-2.781Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C92A4",
    d: "m180.109 74.489.88-2.2 1.343 3.803a.765.765 0 0 0 1.386.126l.833-1.454h1.058a.438.438 0 1 0 0-.875h-1.312a.438.438 0 0 0-.38.22l-.839 1.467-1.361-3.855h-.001a.763.763 0 0 0-1.142-.383.767.767 0 0 0-.288.352l-.879 2.199h-1.016a.438.438 0 1 0 0 .875h1.312c.179 0 .34-.11.406-.275Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C92A4",
    fillRule: "evenodd",
    d: "M186.266 68.639v.437l.001-.437H186.288l.037.002a1.24 1.24 0 0 1 .464.126c.134.067.282.174.394.343a1.1 1.1 0 0 1 .176.622v8.532h-.437.437v.022l-.002.037a1.247 1.247 0 0 1-.126.465 1.014 1.014 0 0 1-.343.393 1.104 1.104 0 0 1-.622.176h-8.532v-.437l-.001.437H177.712c-.01 0-.022 0-.037-.002a1.24 1.24 0 0 1-.464-.126 1.008 1.008 0 0 1-.394-.343 1.1 1.1 0 0 1-.176-.622v-8.532h.437-.437v-.022l.002-.037a1.247 1.247 0 0 1 .126-.465c.067-.133.174-.28.343-.393.172-.115.382-.176.622-.176h8.532Zm-8.75 9.625v-8.529a.384.384 0 0 1 .035-.135.144.144 0 0 1 .047-.057c.012-.009.049-.03.136-.03h8.529a.373.373 0 0 1 .135.036c.03.016.047.031.057.047.009.012.029.049.029.136v8.529a.384.384 0 0 1-.035.135.144.144 0 0 1-.047.057c-.012.009-.049.03-.136.03h-8.529a.373.373 0 0 1-.135-.036.139.139 0 0 1-.057-.047c-.009-.012-.029-.049-.029-.136Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEFF4",
    fillRule: "evenodd",
    d: "M252.138 271.729c20.483 0 37.088-4.478 37.088-10.001 0-5.524-16.605-10.001-37.088-10.001s-37.087 4.477-37.087 10.001c0 5.523 16.604 10.001 37.087 10.001Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#814C74",
    fillRule: "evenodd",
    d: "M241.034 158.534s-4.485-4.653-3.305-7.823c.261-.701 2.017.227 2.839-.904 1.096-1.505.896 3.828.896 3.828l-.43 4.899Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#56557E",
    fillRule: "evenodd",
    d: "M203.978 126.313h-15.97c0-2.284 3.575-4.137 7.985-4.137s7.985 1.853 7.985 4.137Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7CAEB",
    fillRule: "evenodd",
    d: "m239.895 151.029 3.955 106.644 5.475.194 13.186-106.746-22.616-.092Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D9F2",
    fillRule: "evenodd",
    d: "m240.641 153.066 24.801 105.371h5.459s-9.807-79.721-3.074-108.178c1.321-5.58-27.186 2.807-27.186 2.807Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "M204.02 126.3c11.295-.34 30.707.347 30.707.347 1.167.035 9.961-.799 13.851-6.814 5.248-8.12-1.36-19.263-6.518-13.444-4.024 4.539-8.314 10.258-9.376 10.937-6.277 4.006-25.347 7.042-28.192 5.184-4.401-2.876-10.969-1.87-13.66-.139-3.362 2.161 6.38-.532 8.481.18 1.196.407 3.143 3.796 4.707 3.749Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#814C74",
    fillRule: "evenodd",
    d: "m253.604 114.75-11.544 10.807c-1.268 1.311-1.239.442-2.587-.561l-6.789-7.668c3.084-3.421 8.727-15.387 14.447-15.713 10.563-.602 7.741 11.825 6.473 13.135Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "m259.971 89.499-11.842.885 3.46-16.256 6.112-2.425 2.27 17.796Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#A25D91",
    fillRule: "evenodd",
    d: "M266.507 156.628c-7.636-7.097-27.714 3.341-28.874-5.579 0 0 5.967-19.859 2.585-35.792-4.942-23.281 12.575-38.275 18.773-34.745 13.326 7.59 10.462 34.849 9.322 54.663-.597 10.398.683 23.767-1.806 21.453Z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    fillRule: "evenodd",
    d: "M258.325 76.2s-.735-4.01-.735-4.068c0-2.312-6.432-1.258-9.459-1.546-5.56-.528-5.418-13.625-5.418-13.625s-6.76-6.923 1-8.899c1.189-.303 3.993 1.037 5.871.925 5.602-.335 9.891-.535 12.682.682 2.791 1.216 4.46 4.925 4.821 7.45 1.022 7.16-5.786 17.939-8.762 19.081Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CA92",
    fillRule: "evenodd",
    d: "M256.713 69.097c-.481-1.17-5.009 3.036-6.676 5.087 0 0 .984 3.648 2.678 3.955 1.824.333 4.335-2.566 5.237-3.96a25.83 25.83 0 0 0-1.239-5.082Z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "M259.97 64.379c1.808 2.147-.398 2.214-.549 4.58-.283 4.424-7.13 7.549-11.207 8.797-2.666.817-2.663-2.69-4.416-6.637-.366-.827-1.835-.007-2.057-1.943-.075-.653 1.518-3.047 1.428-3.706-.591-4.341-1.677-7.357.382-10.294 0 0 2.672 6.604 8.994 4.587 2.08-.664 4.213 1.488 4.786 3.198.776 2.313.902-.646 2.639 1.418ZM253.426 155.659c4.978-6.089 6.656-34.878 6.656-34.878-4.305-5.029-6.739-20.758-6.739-20.758l10.396-4.033s5.407 14.233 5.777 20.746c.745 13.136-5.799 32.528-11.119 43.879-.601 1.281-1.914 1.874-3.619 2.45-1.113.376-1.709.054-2.791-.391a2.67 2.67 0 0 1-.996-.983c-.633-2.342-1.77-.887 2.435-6.032Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#814C74",
    fillRule: "evenodd",
    d: "M263.361 90.197s4.023 12.619 2.756 13.128l-11.279 3.85c-1.266.509-5.618-13.852-3.544-17.837 3.828-7.354 11.636-.516 12.067.859Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    fillRule: "evenodd",
    d: "M241.382 258.939c.695-.513 2.373-2.513 2.373-2.513h5.772c1.361 1.163 1.115 7.073 1.115 7.073h-18.52c-.511-2.529 7.184-3.028 9.26-4.56ZM262.515 259.226c.695-.513 2.373-2.513 2.373-2.513h5.772c1.36 1.163 1.115 7.073 1.115 7.073h-18.52c-.511-2.529 7.184-3.027 9.26-4.56Z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D7D",
    fillRule: "evenodd",
    d: "M104.462 126.093h-5.804c-2.894 0-4.58-9.868-4.58-9.868 0-.996 1.42-1.811 3.157-1.811h9.267c1.737 0 3.157.815 3.157 1.811 0-.001-2.453 9.868-5.197 9.868Z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5D5D7D",
    strokeWidth: 0.695,
    d: "M105.094 118.596c8.855-5.25 10.146 3.545.578 4.944"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D7D",
    fillRule: "evenodd",
    d: "m98.04 113.078-.305-.27c.012-.013 1.201-1.372 1.028-2.464a1.276 1.276 0 0 0-.683-.923 1.844 1.844 0 0 1-.96-1.343c-.24-1.586 1.495-3.512 1.571-3.592l.301.274c-.017.019-1.68 1.864-1.469 3.258.072.452.355.843.763 1.052.466.244.79.692.879 1.211.202 1.281-1.071 2.736-1.125 2.797ZM101.594 112.809l-.304-.27c.012-.013 1.201-1.373 1.028-2.464a1.281 1.281 0 0 0-.683-.923 1.843 1.843 0 0 1-.96-1.343c-.24-1.586 1.495-3.512 1.571-3.592l.301.274c-.017.019-1.68 1.864-1.469 3.258.072.452.356.843.765 1.052.465.245.79.692.879 1.211.2 1.282-1.073 2.736-1.128 2.797ZM105.735 112.759l-.304-.269c.012-.014 1.2-1.373 1.027-2.465a1.276 1.276 0 0 0-.683-.922 1.844 1.844 0 0 1-.959-1.343c-.239-1.586 1.497-3.512 1.571-3.592l.3.274c-.016.019-1.68 1.864-1.469 3.258.073.452.357.843.765 1.052.466.244.791.692.879 1.211.201 1.281-1.072 2.735-1.127 2.796Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "noactivity",
    x1: 152.455,
    x2: 194.482,
    y1: -22.603,
    y2: 241.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivity);
export default __webpack_public_path__ + "static/media/noActivity.4ea9524ee6cab4f85bea2014fbed263e.svg";
export { ForwardRef as ReactComponent };